// المصدر الوحيد لعناوين حقول الحجز وترتيبها المعتمد (1→22 + حقلان للمالك فقط).
// أي تغيير هنا يغيّر الشاشة والاختبارات معًا — والترتيب ملزم ولا يُعاد ترتيبه في أي شاشة.
export const BK = {
  salesName: 'Sales Name',                    // 1  — نظام (من المستخدم، للقراءة فقط)
  customerName: 'اسم العميل',                  // 2
  phone: 'رقم الهاتف',                         // 3
  bookingType: 'نوع الحجز',                    // 4
  hotelOrVisa: 'اسم الفندق / التاشيرة',        // 5
  nationality: 'الجنسيه',                      // 6
  fromCity: 'من',                              // 7
  transitCity: 'مدينة الترانزيت',              // 8
  toCity: 'الى',                               // 9
  adults: 'عدد البالغين',                      // 10
  children: 'عدد الاطفال',                     // 11
  infants: 'عدد الرضع',                        // 12
  departureDate: 'تاريخ الاقلاع / الدخول',     // 13
  returnDate: 'تاريخ العوده / المغادره',       // 14
  salePrice: 'سعر البيع',                      // 15
  costPrice: 'سعر التكلفة',                    // 16
  costWithTax: 'التكلفة + 3% ضريبه',           // 17 — محسوب على الخادم
  commissionRatePct: 'نسبة العمولة %',         // 18 — محسوب على الخادم
  provisionalCommission: 'العمولة ل Sales',    // 19 — محسوب على الخادم
  executionSource: 'مصدر التنفيذ',             // 20
  // 20 بأجزائه في الحجز المركّب (0124، قرار المالك 23/09/2026): مصدرٌ لكل جزء يُراجَع على حدة
  executionSourceHotel: 'مصدر تنفيذ الفندق',
  executionSourceFlight: 'مصدر تنفيذ الطيران',
  executionSourceVisa: 'مصدر تنفيذ التأشيرة',
  customerRating: 'تقييم العميل',              // 21
  operationType: 'تصنيف العميل',               // 22 — هو نفسه نوع العملية
  grossProfitMarginPct: 'هامش الربح',          // 23 — للمالك/الأدمن فقط
  grossProfit: 'Gross Profit',                 // 24 — للمالك/الأدمن فقط
  // حجز الفندق (0051): تكلفة الفندق + كراسي الباص × تكلفة الكرسي = التكلفة الإجمالية،
  // وهي «سعر التكلفة» نفسه (قبل ضريبة الـ٣٪) — تُحسب على الخادم في أنواع الفندق وحدها.
  hotelCost: 'سعر التكلفة للفندق',
  busSeats: 'عدد كراسي الباص',
  busSeatCost: 'تكلفة الكرسي',
  totalCost: 'التكلفة الإجمالية',
  // تاريخ ميلاد العميل (0085) — **خارج ترتيب الشيت عمدًا**: الترتيب 1→22 نسخةٌ حرفية
  // من الشيتين الأصليين، وإقحامُ عمودٍ بينهما يكسر مطابقةَ التصدير للشيت. فيظهر في
  // الشاشة بجانب اسم العميل وتليفونه (بيانات الإنسان) ولا يدخل ذلك الترتيب.
  dateOfBirth: 'تاريخ ميلاد العميل',
  // اسم الشركة الدافعة (0088) — مع «شركة» وحدها، وخارج ترتيب الشيت كسابقه
  companyName: 'اسم الشركة',
} as const;

/** الترتيب المعتمد للحقول التجارية 1→22 كما يراه البياع والشريك. */
export const BOOKING_FIELD_ORDER: readonly string[] = [
  BK.salesName, BK.customerName, BK.phone, BK.bookingType, BK.hotelOrVisa, BK.nationality,
  BK.fromCity, BK.transitCity, BK.toCity, BK.adults, BK.children, BK.infants,
  BK.departureDate, BK.returnDate, BK.salePrice, BK.costPrice, BK.costWithTax,
  BK.commissionRatePct, BK.provisionalCommission, BK.executionSource, BK.customerRating, BK.operationType,
];

/** حقلان لا يظهران أبدًا للبياع أو الشريك. */
export const OWNER_ONLY_FIELDS: readonly string[] = [BK.grossProfitMarginPct, BK.grossProfit];

/** حجوزات المالك بلا عمولة (rate = 0, source = OWNER) — لا نعرض حقلي العمولة فيها. */
export const hasCommissionFields = (isOwnerBooking: boolean | undefined): boolean => !isOwnerBooking;
